import { Route } from '@tanstack/react-location';
import React, { lazy } from 'react';

const List = lazy(() => import('./List'));

import { AdminRouteBaseProps } from '@/layout/Admin/routes';

export type WebhooksRouteProps = AdminRouteBaseProps;

const WebhooksRoutes: Route<WebhooksRouteProps>[] = [
  {
    path: '/webhooks/',
    id: 'Webhooks',
    children: [
      {
        path: '/',
        id: 'WebhooksList',
        element: <List />,
      },
    ],
  },
];

export const toWebhooks = (): string => `/admin/webhooks/`;

export default WebhooksRoutes;
